export const NoticeData = [
    {
        title: "보안 패치 작업에 따른 제네시스 커넥티드 서비스 이용불가 고객 대상 안내",
        link: "https://www.genesis.com/kr/ko/support/notice.html",
    },
    {
        title: "제네시스 커넥티드 서비스 시스템 개선 작업 안내",
        link: "https://www.genesis.com/kr/ko/support/notice/detail.html?seq=0000000411",
    },
    {
        title: "Genesis Connected Services 개인정보 처리방침 개정 공지",
        link: "https://www.genesis.com/kr/ko/support/notice/detail.html?seq=0000000408",
    },
    {
        title: "제네시스 커넥티드 서비스 시스템 개선 작업 안내",
        link: "https://www.genesis.com/kr/ko/support/notice/detail.html?seq=0000000406",
    },
    {
        title: "제GV60 페이스 커넥트 시스템 등록불량 개선 무상수리 고객통지문",
        link: "https://www.genesis.com/kr/ko/support/notice/detail.html?seq=0000000394",
    },
    {
        title: "제네시스 멤버십 제휴서비스 종료 안내 입니다.",
        link: "https://www.genesis.com/kr/ko/support/notice/detail.html?seq=0000000405",
    }
]